import { createEvent, type EventCallable } from 'effector'
import { type SignUpMethod } from '~/shared/analytics/index.h'

/**
 * A social provider button was clicked, on either auth form.
 *
 * The button is a plain link: the browser leaves the app, and everything held in
 * a store is gone by the time the provider sends the user back. Anything that has
 * to survive that round trip is persisted from this event (OVP-3049).
 */
export const socialAuthStarted: EventCallable<SignUpMethod> = createEvent()
